export default ($axios) => ({
  fetch(query) {
    return $axios.get('/email/reports', { params: query }).then((response) => response.data);
  },
  download(id) {
    return $axios.get(`/email/reports/${id}`, { responseType: 'arraybuffer' });
  },
});
